import React, { useEffect, useMemo, useRef, useState } from 'react';

import style from './App.module.scss';
import classnames from 'classnames';
import Plans from '../Plans/Plans';
import swiperAnimation from '../../assets/images/animation.gif'
import { useSearchParams } from 'react-router-dom';
import Almanac from '../Almanac/Almanac';
import { sportsDict } from '../../constants';
import { IBoughtOnePaymentItem, IOnePaymentItem, IPlan, ISubscription, ModeEnum } from '../../model';
import RenewNowModal from '../RenewNowModal/RenewNowModal';
import { AppContext } from '../../context/AppContext';

interface IProps {
  mode: ModeEnum;
}

const tokenHardcoded = 'efds.eyJ1c2VyX2lkIjoxNTYxMzcsInR5cGUiOiJhY2Nlc3MiLCJtb2RlIjoiZGV2IiwiZXhwIjoxNzM1MDM0MTQ5fQ.J1rQje_311F3WmwfhMYxUAe5b9YzTql3A0wWd1PLgpE'
// @ts-ignore
// window.baseURL = 'https://ftn-staging.dfsforecast.com';
if (process.env.NODE_ENV === 'development') {
// @ts-ignore
  window.baseURL = 'https://ftn-staging.dfsforecast.com';
// @ts-ignore
  // window.baseURL = 'https://ftn-staging.dfsforecast.com';
  // @ts-ignore
  window.defaultSport = 'all';
}

const highStakes = ['prod_PlfFOJkm1ZrTWI', 'prod_PsUC4S5chF5FRz', 'prod_PZNcF6CTejkodM', 'prod_P5Lil1p2rCsgQc', 'prod_P8N3KdnMzCmSAC', 'prod_PuHKojyjGAoT2a'];
// @ts-ignore
const defaultSport = window.defaultSport || 'all'

function App({mode}: IProps) {
  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedSport, setSelectedSport] = useState(defaultSport);
  const [baseCheckoutPath, setBaseCheckoutPath] = React.useState<string>('/checkout');

  const [yearly, setYearly] = useState<boolean>(searchParams.get('period') !== 'monthly');
  // const selectedOneTimeItemId = searchParams.get('one-time-item');

  const [plans, setPlans] = useState<IPlan[]>([]);
  const [onePaymentItems, setOnePaymentItems] = useState<IOnePaymentItem[] | undefined>();
  const [boughtOnePaymentItems, setBoughtOnePaymentItems] = useState<IBoughtOnePaymentItem[] | undefined>();
  const [subscriptions, setSubscriptions] = useState<ISubscription[]>([]);

  const [renewPopup, showRenewPopup] = useState<null | { plan: IPlan }>(null);

  const [isSubscriptionsLoading, setIsSubscriptionsLoading] = useState<boolean>(true);

  const filteredOnePaymentItems = useMemo(() => {
    if (!onePaymentItems) return [];
    return onePaymentItems.filter(item => !boughtOnePaymentItems?.find(boughtItem => boughtItem.item.id === item.id));
  }, [onePaymentItems, boughtOnePaymentItems])

  useEffect(() => {
    const newSearchParams = new URLSearchParams(searchParams);
    if (!yearly) {
      newSearchParams.set('period', 'monthly')
    } else {
      newSearchParams.delete('period')
    }
    if (window.location.pathname.indexOf('/pricing') !== -1) {
      setSearchParams(newSearchParams)
    }
  }, [yearly])

  useEffect(() => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('sport', selectedSport)
    if (window.location.pathname.indexOf('/pricing') !== -1) {
      setSearchParams(newSearchParams);
    }
  }, [selectedSport])

  const loadAuthorizedData = async () => {
    console.log('loadAuthorizedData: ');
    if (process.env.NODE_ENV === 'development') {
      // @ts-ignore
      await fetch(`${window.baseURL}/subscriptions/`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${tokenHardcoded}`
        }
      })
        .then(res => res.json())
        .then((response) => {
          setIsSubscriptionsLoading(false)
          if (Array.isArray(response)) {
            setSubscriptions(response);
          } else {
            setSubscriptions([]);
          }
        }).catch(() => {
          setIsSubscriptionsLoading(false);
        });

      // @ts-ignore
      await fetch(`${window.baseURL}/subscriptions/one-time-payment/user/items`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${tokenHardcoded}`
        }
      })
        .then(res => res.json())
        .then((response) => {
          if (Array.isArray(response)) {
            setBoughtOnePaymentItems(response);
          } else {
            setBoughtOnePaymentItems([]);
          }
        });
    } else {
      console.log('else: ');
      // @ts-ignore
      window.getAccessToken({needRedirectToSignIn: false}).then(async accessToken => {
        console.log('accessToken: ', accessToken);
        if (!accessToken) {
          setIsSubscriptionsLoading(false);
          setBaseCheckoutPath(`/sign-up?referrer=${window.location.origin}/checkout`);
          return;
        }
        // @ts-ignore
        await fetch(`${window.baseURL}/subscriptions/`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          }
        })
          .then(res => res.json())
          .then((response) => {
            if (Array.isArray(response)) {
              setSubscriptions(response);
            } else {
              setSubscriptions([]);
            }
            setIsSubscriptionsLoading(false)
          })
          .catch(() => {
            setIsSubscriptionsLoading(false);
          })

        // @ts-ignore
        await fetch(`${window.baseURL}/subscriptions/one-time-payment/user/items`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          }
        })
          .then(res => res.json())
          .then((response) => {
            if (Array.isArray(response)) {
              setBoughtOnePaymentItems(response);
            } else {
              setBoughtOnePaymentItems([]);
            }
          });
      }).catch(() => {
        setIsSubscriptionsLoading(false);
        setBoughtOnePaymentItems([]);
        setBaseCheckoutPath(`/sign-up?referrer=${window.location.origin}/checkout`);
      })
    }
  }

  useEffect(() => {
    // @ts-ignore
    fetch(`${window.baseURL}/plans/`)
      .then(res => res.json())
      .then((response) => {
        setPlans(response);
      });
    // @ts-ignore
    fetch(`${window.baseURL}/subscriptions/one-time-payment/items`)
      .then(res => res.json())
      .then((response) => {
        setOnePaymentItems(response);
      })
  }, []);

  useEffect(() => {
    setIsSubscriptionsLoading(true);
    // setSubscriptions([
    //   {
    //     'subscription_id': 'sub_1PQblmAoRiRnxiYjCiCnYqzw',
    //     'status': 'active',
    //     'billing_cycle_anchor': 1718139498,
    //     'cancel_at_period_end': false,
    //     'canceled_at': null,
    //     'created_at': 1718139498,
    //     'current_period_end': 1749675498,
    //     'current_period_start': 1718139498,
    //     'trial_start': null,
    //     'trial_end': null,
    //     'discount': {},
    //     'plans': [
    //       {
    //         'plan_id': 'prod_PsUC4S5chF5FRz',
    //         'display_name': 'High Stakes All Sports',
    //         'price_id': 'price_1P4SmCAoRiRnxiYj4d6bXNSF',
    //         'price': '2599',
    //         'interval': 'month'
    //       }
    //     ]
    //   },
    //   {
    //     'subscription_id': 'sub_1PQblmAoRiRnxiYjCiCnYqzw',
    //     'status': 'active',
    //     'billing_cycle_anchor': 1718139498,
    //     'cancel_at_period_end': false,
    //     'canceled_at': null,
    //     'created_at': 1718139498,
    //     'current_period_end': 1749675498,
    //     'current_period_start': 1718139498,
    //     'trial_start': null,
    //     'trial_end': null,
    //     'discount': {},
    //     'plans': [
    //       {
    //         'plan_id': 'prod_PZNeCNoAFYNLKT',
    //         'display_name': 'Bets+',
    //         'price_id': 'price_1P47igAoRiRnxiYjJu4fuvO4',
    //         'price': '15999',
    //         'interval': 'year'
    //       }
    //     ]
    //   }
    // ])
    // setIsSubscriptionsLoading(false)
    loadAuthorizedData();
  }, []);

  const subscribedPlans = useMemo(() => {
    return subscriptions.map(subscription => subscription.plans.map(plan => {
      return {
        ...plan,
        subscription
      }
    })).flat(1);
  }, [subscriptions])

  const fillChildPlans = (plan: IPlan) => {
    plan.childPlans = plan.encapsulated_plans.map(planId => plans.find(foundPlan => foundPlan.plan_id === planId)).filter(Boolean) as IPlan[];
    plan.childPlans.forEach(fillChildPlans);
  }

  let {
    plans: filteredPlans,
    totalPrice,
    maxCurrent
  } = useMemo(() => {
    let maxCurrent = 0;

    const subscribedPlanIds = subscribedPlans.map(plan => plan.plan_id);
    plans.forEach((plan) => {
      if (subscribedPlanIds.includes(plan.plan_id) && (plan.display.sport_category === selectedSport || plan.display.sport_category === 'all')) {
        maxCurrent = Math.max(maxCurrent, plan.plan_tier);
      }
    })

    const filtered = plans.filter(plan => plan.display.sport_category === selectedSport);
    const highStakesPlans = plans.filter(plan => highStakes.includes(plan.plan_id))

    let totalPrice = 0;
    const resPlans = filtered.filter(plan => !highStakes.includes(plan.plan_id)).map(plan => {
      const additional = highStakesPlans.find(stake => stake.encapsulated_plans.includes(plan.plan_id));

      const foundPlan = subscribedPlans.find(findPlan => findPlan.plan_id === plan.plan_id);
      if (foundPlan) {
        totalPrice += Number(foundPlan.interval === 'year' ? Number(foundPlan.price) / 12 : foundPlan.price) / 100;

        if (plan.plan_tier > maxCurrent) maxCurrent = plan.plan_tier;
        plan.current = foundPlan;
      }

      if (additional) {
        plan.additional = additional;
        const foundAdditionalPlanCurrent = subscribedPlans.find(findPlan => findPlan.plan_id === additional?.plan_id);
        if (foundAdditionalPlanCurrent) {
          plan.additional.current = foundAdditionalPlanCurrent;
        }
      }
      return plan;
    }).sort((plan1, plan2) => {
      const diff = plan1.plan_tier - plan2.plan_tier;
      if (diff === 0) {
        return plan1.plan_id > plan2.plan_id ? 1 : -1;
      }
      return diff;
    });

    resPlans.forEach(fillChildPlans);

    return {
      maxCurrent,
      plans: resPlans,
      totalPrice
    }
  }, [plans, subscriptions, selectedSport, subscribedPlans]);

  const maxPlan = plans.filter(plan => plan.plan_tier === 4 && plan.display.sport_category === 'all')?.[0];
  const maxPlanSplitPrice = (maxPlan?.prices.yearly?.unit_amount / 100 / 12).toFixed(2).split('.');

  // const selectedOneTimeItem = Array.isArray(filteredOnePaymentItems)
  //   ? filteredOnePaymentItems?.find(item => item.string_id === selectedOneTimeItemId)
  //   : undefined;

  const almanac = Array.isArray(filteredOnePaymentItems) ? filteredOnePaymentItems?.find(item => item.string_id === '2024_almanac') : undefined;

  const sports = useMemo(() => {
    let sports: string[] = [];
    plans.forEach(plan => {
      sports = [...sports, plan.display.sport_category];
    });

    const querySport = searchParams.get('sport');
    if (querySport) {
      setSelectedSport(querySport);
    } else {
      setSelectedSport(defaultSport)
    }
    return Array.from(new Set(sports))
      .sort((plan1, plan2) => {
        if (plan1 === 'all') return 1;
        if (plan2 === 'all') return -1;
        return 0;
      });
  }, [plans])


  let oneTimeItemPlansWithDiscount = subscribedPlans.filter((plan) => {
    const planCategory = plans.find(p => p.plan_id === plan.plan_id)?.display.sport_category;
    return (plan.interval === 'year' ? 'yearly' : 'monthly') === almanac?.subscriber_period_restriction
      && planCategory && (almanac?.subscriber_sports_restriction.includes(planCategory) || planCategory === 'all');
  });

  const activeDiscounts = almanac?.discounts.filter(discount => {
    return oneTimeItemPlansWithDiscount.find(plan => discount.plan_id === plan.plan_id && discount.period_restriction === (plan.interval === 'year' ? 'yearly' : 'monthly'))
  });

  let hasAdditionalDiscount = !!oneTimeItemPlansWithDiscount?.length;

  if(mode === ModeEnum.full){
    hasAdditionalDiscount = false;
  }

  if (activeDiscounts && hasAdditionalDiscount) {
    filteredPlans = plans.filter(plan => almanac?.discounts.find(discount => discount.plan_id === plan.plan_id)).sort((plan1, plan2) => {
      if (plan1.display.sport_category !== plan2.display.sport_category) {
        if (plan1.display.sport_category === 'all') return 1
        if (plan2.display.sport_category === 'all') return -1
      }
      return plan1.plan_tier - plan2.plan_tier
    });
  }

  const renderPlans = useMemo(() => {
    return filteredPlans.map(plan => ({
      ...plan,
      childPlans: plan.encapsulated_plans.map(planId => plans.find(foundPlan => foundPlan.plan_id === planId)).filter(Boolean) as IPlan[]
    }))
  }, [filteredPlans]);

  if (mode === ModeEnum.widget) {
    if (!almanac) return <></>;
    return <Almanac
      baseCheckoutPath={baseCheckoutPath}
      oneTimePaymentItem={almanac}
      currentPrice={
        activeDiscounts?.length ? (almanac.subscriber_price - (activeDiscounts?.reduce(
          (acc, discount) => {
            return Math.max(acc, discount.amount_off)
          }, 0) || 0)) : (oneTimeItemPlansWithDiscount.length ? almanac.subscriber_price : almanac.base_price)
      }
      mode={ModeEnum.widget}
    />
  }


  return (
    <AppContext.Provider value={{
      yearly,
      maxCurrent,
      totalPrice,
      // selectedOneTimeItem,
      // oneTimeItem: almanac,
      baseCheckoutPath,
      showRenewPopup
    }}>
      <div className={classnames(style.container)} style={{paddingBottom: 30, overflow: 'hidden'}}>
        <div className={style.header}>
          <h1 className={style.title}>Plans</h1>
            <div className={style.switch}>
              <label className={style.switch_wrapper}>
                <input type="checkbox" name="price-period" value="Yearly" checked={yearly}/>
                <span className={style.switch_option} onClick={() => setYearly(false)}>Monthly</span>
                <span className={style.switch_toggle} onClick={() => {
                  setYearly(!yearly)
                }}></span>
                <span className={style.switch_option} onClick={() => setYearly(true)}>
              Annually
              <span className={style.badge}>save up to 50%</span>
            </span>
              </label>
          </div>
          <div
            className={classnames(style.sport_switch_wrapper, {[style.center]: (activeDiscounts && hasAdditionalDiscount)})}>
            <div className={classnames('tab-primary sport-switch', style.sport_switch)}>
              {sports.map(sport => {
                return (<label className={style.sport_switch_input}>
                  <input type="radio" name="sport" value={sport} checked={selectedSport === sport} onChange={(e) => {
                    console.log('set onChange')
                    setSelectedSport(e.target.value);
                  }}/>
                  <div className={classnames('tab-primary__item', style.sport_switch_item)}>
                    {/* @ts-ignore */}
                    {sportsDict[sport] || sport}
                    {sport === 'all' ? <div className={style.badge}>
                      <div className={style.badge_title}>
                        {maxPlan?.display?.name}
                      </div>
                      <div className={style.badge_price}>
                        $ <span>{maxPlanSplitPrice[0]}</span>.{maxPlanSplitPrice[1]}<sub>/mo</sub>
                      </div>
                    </div> : ''}
                  </div>
                </label>);
              })}
            </div>
          </div>
          <div className={classnames(style.scroll_sentence)}>
          <span className={classnames(style.scroll_sentence_text)}>
            Swipe
            <span className={classnames(style.scroll_sentence_sticker)}>
              <img src={swiperAnimation} alt={'image sticker'} />
            </span>
            for more options
          </span>
          </div>
        </div>
        <div className={classnames(style.loader_wrapper, {[style.show]: isSubscriptionsLoading})}>
          <div className={classnames(style.loader)} style={{margin: '0 auto'}}>
            <span/><span/><span/><span/><span/>
          </div>
        </div>
        <div className={style.sport_info_block__wrapper}>
          {selectedSport === 'mlb' ? <div className={style.sport_info_block}>
            You may add <strong>Baseball</strong> either through a baseball only plan or select <strong>All
            Sports</strong>
          </div> : ''}
        </div>

        {!isSubscriptionsLoading ?
          <Plans plans={renderPlans} /> : ''}
      </div>
      {renewPopup ? <RenewNowModal plan={renewPopup.plan} close={() => showRenewPopup(null)}/> : ''}
    </AppContext.Provider>
  );
}

export default App;
